import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import FormatPrice from "../helper/FormatPrice";
import { AuthContext } from "../context/AuthContext";

const OrderPlaced = () => {
  const location = useLocation();
  const { state } = location;

  const { token, userName, emailId } = useContext(AuthContext);

  // Check if the state object exists before attempting to destructure its properties
  if (!state) {
    // Handle the case when state is null or not set
    return (
      <>
        <h1>No Order Placed</h1>
        <div>No data available</div>
      </>
    );
  }

  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed, so we add 1 and pad with '0' if needed.
  const day = String(today.getDate()).padStart(2, "0");

  const formattedDate = `${day}-${month}-${year}`;

  // Destructure the data from the state object
  const {
    email,
    shippingData,
    billingData,
    paymentData,
    cartItems,
    totalAmnt,
  } = state;

  const cartItemsMap = cartItems.map((curElem, index) => {
    return (
      <>
        {token && (
          <tr key={index} className="">
            <td>
              {curElem.product_sku}
              {curElem.product_id}
            </td>
            <td> {curElem.product_sku}</td>
            <td> {curElem.product_name}</td>
            <td>
              {" "}
              <FormatPrice price={curElem.price} />
            </td>
            <td> {curElem.qty}</td>
            <td>
              <FormatPrice price={curElem.qty * curElem.price} />
            </td>
          </tr>
        )}

        {!token && (
          <tr key={index} className="">
            <td> {curElem.id}</td>
            <td> {curElem.sku}</td>
            <td> {curElem.name}</td>
            <td>
              {" "}
              <FormatPrice price={curElem.price} />
            </td>
            <td> {curElem.qty}</td>
            <td>
              <FormatPrice price={curElem.qty * curElem.price} />
            </td>
          </tr>
        )}
      </>
    );
  });

  return (
    <>
      <section>
        <div className="container">
          <div className="row">
            <h2 className="my-5">
              <b>Order Placed Successfully !!!!</b>
            </h2>

            <h5>Thank you {userName}. Your order has been received :)</h5>

            <div className="pb-5 pt-3 col-12">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">Order number</th>
                    <th scope="col">Date</th>
                    <th scope="col">Email</th>
                    <th scope="col">Total</th>
                    <th scope="col">Payment method</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">12364</th>
                    <td>{formattedDate}</td>
                    <td>{emailId}</td>
                    <td>
                      <FormatPrice price={totalAmnt} />
                    </td>
                    <td>Online Payment</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="mb-5 p-4 border col-12">
              <h4 className="mb-4">
                <b>Order Details</b>
              </h4>
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">Product ID</th>
                    <th scope="col">SKU</th>
                    <th scope="col">Name</th>
                    <th scope="col">Price</th>
                    <th scope="col">Quantity</th>
                    <th scope="col">Total</th>
                  </tr>
                </thead>

                <tbody>{cartItemsMap}</tbody>

                <tfoot className="border-top-2">
                  <tr>
                    <td scope="row" colSpan={5}>
                      <b>Payment method</b>
                    </td>
                    <td>Online Payment</td>
                  </tr>
                  <tr>
                    <td scope="row" colSpan={5}>
                      <b>Subtotal</b>
                    </td>
                    <td>
                      <b>
                        <FormatPrice price={totalAmnt} />
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td scope="row" colSpan={5}>
                      <b>Shipping</b>
                    </td>
                    <td>Free shipping</td>
                  </tr>
                  <tr>
                    <td scope="row" colSpan={5}>
                      <b>Total</b>
                    </td>
                    <td>
                      <b>
                        <FormatPrice price={totalAmnt} />
                      </b>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div className="d-flex w-100 p-0">
              <div className="p-4  w-100 border me-3">
                <h4 className="mb-4">
                  <b>Shipping Address</b>
                </h4>
                <p>
                  <b className="">Full Name :</b>{" "}
                  {shippingData.shipping_user_name}
                </p>
                <p>
                  <b className="">Address :</b> {shippingData.shippingAddress1},{" "}
                  {shippingData.shippingAddress2}
                </p>
                <p>
                  <b className="">ZipCode :</b> {shippingData.shippingPin_code}
                </p>
                <p>
                  <b className="">City :</b> {shippingData.shippingCity}
                </p>
                <p>
                  <b className="">State :</b> {shippingData.shippingState}
                </p>
                <p>
                  <b className="">Country :</b> {shippingData.shippingCountry}
                </p>
                {/* Display other relevant data here */}
              </div>
              <div className="p-4  w-100 border">
                <h4 className="mb-4">
                  <b>Billing Address</b>
                </h4>
                <p>
                  <b className="">Full Name :</b>{" "}
                  {billingData.billing_user_name}
                </p>
                <p>
                  <b className="">Address :</b> {billingData.billingAddress1},{" "}
                  {billingData.billingAddress2}
                </p>
                <p>
                  <b className="">ZipCode :</b> {billingData.billingPin_code}
                </p>
                <p>
                  <b className="">City :</b> {billingData.billingCity}
                </p>
                <p>
                  <b className="">State :</b> {billingData.billingState}
                </p>
                <p>
                  <b className="">Country :</b> {billingData.billingCountry}
                </p>
                {/* Display other relevant data here */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OrderPlaced;
